import React from "react";
import { Redirect } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useGestionCustomers } from "hooks/useGestionCustomers";
import { GESTION_ROUTES } from "constants/gestion-routes";
import { ROUTES } from "constants/routes";

const GestionCustomerRedirect = () => {
  const { gestionCustomers, loading } = useGestionCustomers();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" sx={{ py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (gestionCustomers.length === 0) {
    return <Redirect to={ROUTES.ADMIN.DASHBOARD} />;
  }

  return <Redirect to={GESTION_ROUTES.dashboard(gestionCustomers[0].id)} />;
};

export default GestionCustomerRedirect;
